"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PUSH_REQUEST_CLOSED_TIMESTAMP = exports.PUSH_REQUEST_CLOSED_COUNT = exports.ONE_DAY_IN_MINUTES = exports.MAX_CLOSE_COUNT = void 0;
var PUSH_REQUEST_CLOSED_COUNT = exports.PUSH_REQUEST_CLOSED_COUNT = 'pushRequestClosedCount';
var PUSH_REQUEST_CLOSED_TIMESTAMP = exports.PUSH_REQUEST_CLOSED_TIMESTAMP = 'pushRequestClosedTimestamp';
var MAX_CLOSE_COUNT = exports.MAX_CLOSE_COUNT = 3;
var ONE_DAY_IN_MINUTES = exports.ONE_DAY_IN_MINUTES = 60 * 24;